import { RobotIcon } from 'assets/icons';
import format from 'date-fns/format';
import React, { useMemo } from 'react';
import Tooltip from 'shared/components/Tooltip';
import { AutomationRunActionFragment, AutomationRunActionType } from 'shared/types/graphql';
import styled from 'styled-components/macro';

interface IAutomationRunGeneralPromptProps {
  automationRunAction: AutomationRunActionFragment | undefined;
  actionIndex: number;
}

const AutomationRunGeneralPrompt = ({
  automationRunAction,
  actionIndex,
}: IAutomationRunGeneralPromptProps): JSX.Element => {
  const isAnswer = useMemo(() => {
    if (automationRunAction?.actionType === AutomationRunActionType.PetParent) {
      return true;
    }
    return false;
  }, [automationRunAction]);

  const sentTime = format(new Date(automationRunAction?.createdAt), 'h:mmaaa');

  return (
    <PromptWrapper>
      {actionIndex > 0 && !isAnswer && (
        <ChildAutomationStart>
          <AutomationSent>
            Automation Sent <SentTime>{sentTime}</SentTime>
          </AutomationSent>

          {automationRunAction?.order === 1 && actionIndex !== 0 && (
            <Tooltip content={automationRunAction.automationAction?.workflowEventSetting?.name}>
              <RobotIcon />
            </Tooltip>
          )}
        </ChildAutomationStart>
      )}
      {!isAnswer ? <Question>{automationRunAction?.body}</Question> : <Answer>{automationRunAction?.body}</Answer>}
    </PromptWrapper>
  );
};

export default AutomationRunGeneralPrompt;

const Question = styled.div`
  margin: 4px 0 0 0;
  font-size: 16px;
  white-space: pre-wrap;
`;

const Answer = styled.div`
  background-color: var(--chakra-colors-background-primaryAlpha-hover);
  border-left: 4px solid var(--chakra-colors-border-brand);
  padding: 12px;
  font-size: 16px;
  margin-top: -20px;
  white-space: pre-wrap;
`;

const ChildAutomationStart = styled.div`
  display: flex;
  margin-top: 14px;
  align-items: center;
`;

const AutomationSent = styled.div`
  font-weight: 600;
  margin-right: 8px;
  font-size: 14px;
`;
const SentTime = styled.span`
  font-size: 12px;
  color: var(--chakra-colors-text-subtle);
  font-weight: 400;
`;

const PromptWrapper = styled.div`
  padding: 20px 24px;
`;
